import styled from 'styled-components';
import { mix } from '$ui/Flo/util';

export const Container = styled.div`
    ${mix.padding({ padding: 2 })};
`;
